import SkuModel from 'volta/models/sku';
import SkuModalService, { TSkuDetailModalTab } from 'volta/services/sku-modal-service';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface ISkuDetailsArgs {
  skuId: string;
  sku?: SkuModel;
  partCode: string;
  skuDescription: string;
  acqCode: string;
  tab: TSkuDetailModalTab;
  onClose: () => void;
  onSkuChange: () => void;
  options?: object;
  baseSkuPath?: string;
  switchTab: (tab: TSkuDetailModalTab) => void;
}

export interface ISkuPagePrefs {
  executionPoView?: string;
}

export default class SkuDetails extends Component<ISkuDetailsArgs> {
  @service skuModalService!: SkuModalService;

  @tracked skuIsDirty: boolean = false;

  // Computed Properties
  // ~~~~~

  @action
  handleClose() {
    if (this.skuIsDirty) {
      this.skuModalService.unsavedSkuEdits = true;
    } else {
      this.skuModalService.unsavedSkuEdits = false;
      this.args.onClose?.();
    }
  }
}
